import { render, staticRenderFns } from "./ControlePj.vue?vue&type=template&id=4031c541&scoped=true"
import script from "./ControlePj.vue?vue&type=script&lang=js"
export * from "./ControlePj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031c541",
  null
  
)

export default component.exports